import { createPlugin } from 'leva/plugin'
import { Bounce } from './Bounce'
import { normalize, sanitize } from '../utilities/bounce-plugin'

export const bounce = createPlugin({
  normalize,
  sanitize,
  component: Bounce,
})